import React, { PureComponent } from "react";
import "./tag.css";

export default class Tag extends PureComponent {
    static get defaultProps() {
        return {
            color: "white"
        };
    }

    static get propTypes() {
        return {
            text: React.PropTypes.string.isRequired,
            color: React.PropTypes.string,
        };
    }

    render() {
        return (
            <div className="appointment-tag" style={{ background: this.props.color }}>
                {this.props.text}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/tag.js
 **/